<script>
export default {
  name: "SearchLoop",
};
</script>
<template>
<svg class="svg-loop-searchbox" xmlns="http://www.w3.org/2000/svg" width="30.001" height="30" viewBox="0 0 30.001 30">
  <path id="Tracé_20" data-name="Tracé 20" d="M23.386,23.385a1.875,1.875,0,0,1,2.653,0L33.257,30.6a1.875,1.875,0,0,1-2.651,2.653l-7.218-7.218a1.875,1.875,0,0,1,0-2.653Z" transform="translate(-3.806 -3.805)" fill="#ae6b6b" fill-rule="evenodd"/>
  <path id="Tracé_21" data-name="Tracé 21" d="M12.188,22.5A10.313,10.313,0,1,0,1.875,12.188,10.313,10.313,0,0,0,12.188,22.5ZM24.375,12.188A12.188,12.188,0,1,1,12.188,0,12.188,12.188,0,0,1,24.375,12.188Z" transform="translate(0 0)" fill="#ae6b6b" fill-rule="evenodd"/>
</svg>

</template>
